import { call, put, takeLatest, fork, all } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as Func from "../helpers/functions";
import { parseListRequestParams } from '../utils/commonUtils';
import i18n from '../constants/initLng';
import { PATHS } from '../constants/Define';
import { get } from 'lodash';
import * as TourTicketActions from '../actions/tourTicketAction';
import * as TourTicketService from './../services/tourTicketService';
import history from '../helpers/history';


function* getListTourTicket() {
    yield takeLatest(Types.TOUR_TICKET_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParams(action.filters || {});
        const result = yield call(TourTicketService.getTourTickets, params);
        yield put(TourTicketActions.dataTourTicketSuccess(result));
    }, errorHandleTourTicket(Types.TOUR_TICKET_FAIL)))
}

function* getAllListTourTicket() {
    yield takeLatest(Types.TOUR_TICKET_LIST_ALL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourTicketService.getAllTourTickets);
        yield put(TourTicketActions.setAllTickets(result));
    }, errorHandleTourTicket(Types.TOUR_TICKET_FAIL)))
}

function* getTourTicketDetail() {
    yield takeLatest(Types.TOUR_TICKET_GET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourTicketService.getTourTicketDetail, action.params.id);
        yield put(TourTicketActions.getUpdateTourTicketSuccess(result));
    }, errorHandleTourTicket(Types.TOUR_TICKET_FAIL)))
}

function* createTourTicket() {
    yield takeLatest(Types.TOUR_TICKET_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const tourTicket = action.params.data;
        yield call(TourTicketService.createTourTicket, tourTicket);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), tourTicket.name);
        history.push(PATHS.TOUR_TICKET.LIST.path);
        history.go();
    }, errorHandleTourTicket(Types.TOUR_TICKET_FAIL)))
}

function* updateTourTicket() {
    yield takeLatest(Types.TOUR_TICKET_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const tourTicket = action.params.data;
        yield call(TourTicketService.updateTourTicket, tourTicket);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), tourTicket.name);
        yield put({ type: Types.TOUR_TICKET_UPDATE_SUCCESS });
        history.push(PATHS.TOUR_TICKET.LIST.path);
        history.go();
    }, errorHandleTourTicket(Types.TOUR_TICKET_FAIL)))
}

function* deleteTourTicket() {
    yield takeLatest(Types.TOUR_TICKET_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourTicketService.deleteTourTicket, action.params.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'));
        yield put({ type: Types.TOUR_TICKET_LIST_ACTION, filters: action.params.PageIndex })
    }, errorHandleTourTicket(Types.TOUR_TICKET_FAIL)))
}

// TRANSLATE
function* createTourTicketTranslate() {
    yield takeLatest(Types.TOUR_TICKET_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourTicketService.createTourTicketTranslate, action.tourTicket);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.tourTicket.translate.languageName);
        yield put({ type: Types.TOUR_TICKET_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.TOUR_TICKET_GET_UPDATE_ACTION, params: { id: action.tourTicket.id } });
    }, errorHandleTourTicket(Types.TOUR_TICKET_FAIL)))
}

function* updateTourTicketTranslate() {
    yield takeLatest(Types.TOUR_TICKET_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourTicketService.updateTourTicketTranslate, action.tourTicket);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.tourTicket.translate.languageName);
        yield put({ type: Types.TOUR_TICKET_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.TOUR_TICKET_GET_UPDATE_ACTION, params: { id: action.tourTicket.id } });
    }, errorHandleTourTicket(Types.TOUR_TICKET_FAIL)))
}

function* deleteTourTicketTranslate() {
    yield takeLatest(Types.TOUR_TICKET_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(TourTicketService.deleteTourTicketTranslate, action.tourTicket.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.tourTicket.translate.languageName);
        yield put({ type: Types.TOUR_TICKET_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.TOUR_TICKET_GET_UPDATE_ACTION, params: { id: action.refreshParams.id } });
    }, errorHandleTourTicket(Types.TOUR_TICKET_FAIL)))
}

function* getAllListTourTicketById() {
    yield takeLatest(Types.TOUR_TICKET_LIST_ALL_BY_ID_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(TourTicketService.getAllTourTicketsById, action.id);
        yield put(TourTicketActions.setAllTicketsById(result));
    }, errorHandleTourTicket(Types.TOUR_TICKET_LIST_ALL_BY_ID_FAIL)))
}

function errorHandleTourTicket(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'tourTicket');
}

export function* tourTicketSaga() {
    yield all([
        fork(getListTourTicket),
        fork(createTourTicket),
        fork(deleteTourTicket),
        fork(getTourTicketDetail),
        fork(updateTourTicket),
        fork(createTourTicketTranslate),
        fork(updateTourTicketTranslate),
        fork(deleteTourTicketTranslate),
        fork(getAllListTourTicket),
        fork(getAllListTourTicketById),
    ])
}
